<div class="h-full flex flex-col overflow-hidden bg-[var(--main-light)]">
  <ng-container *ngIf="!isLoading">
    <mat-card class="p-4 rounded-2xl bg-[var(--main)] z-10">
      <div class="flex items-center gap-2">
        <h5 class="flex-1 font-semibold">
          {{ administre.administre_ID === 0 ? 'Création d\'un compte administré'
          : administre.administre_RS || 'Modification d\'un compte administré'
          }}
        </h5>
        <div class="flex items-center gap-2">
          <button
            class="btn-fab txt-primary"
            (click)="postAdministre()"
            matTooltip="Enregistrer"
          >
            <mat-icon>save</mat-icon>
          </button>
          <button
            *ngIf="administre.administre_ID !== 0"
            class="btn-fab txt-danger"
            (click)="deleteAdministre()"
            matTooltip="Supprimer"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button class="btn-fab" (click)="close()" matTooltip="Fermer">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>

    <mat-tab-group
      class="action-tabs flex-1 no-margin-field-bottom text-[var(--text)]"
    >
      <mat-tab label="Informations">
        <div class="overflow-auto" style="max-height: calc(100dvh - 200px)">
          <app-informations [administre]="administre"></app-informations>
        </div>
      </mat-tab>
      <mat-tab label="Banque">
        <div class="overflow-auto" style="max-height: calc(100dvh - 200px)">
          <app-banque [administre]="administre"></app-banque>
        </div>
      </mat-tab>
      <mat-tab label="Notes">
        <div class="relative p-4">
          <mat-card class="bg-[var(--main-card)]">
            <quill-editor
              [(ngModel)]="administre.administre_Notes"
              [styles]="{height: '500px'}"
              placeholder="Ecrivez vos notes ici..."
            ></quill-editor>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="flex-1 flex items-center justify-center p-4">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>
</div>
